import * as React from "react";
import { connect } from "react-redux";

import Dimensions from "react-dimensions";

import Calendar from "./Calendar";

export interface IResponsiveCalendar {
    containerWidth: number;
    displayedEventId: number;
    eventScreenMode: string;
    iCalStartDate: Date;
    portletInstanceId: number;
    viewMode: string;
    openDisplayEventsFromOtherCalendarsModal: (open: boolean) => any;
    onWidthChanged: (width: number) => any;
}

class ResponsiveCalendar extends React.Component<IResponsiveCalendar, any> {

    constructor(props, context) {
        super(props, context);
    }

    public render() {

        return (
            <Calendar
                displayedEventId={this.props.displayedEventId}
                eventScreenMode={this.props.eventScreenMode}
                iCalStartDate={this.props.iCalStartDate}
                portletInstanceId={this.props.portletInstanceId}
                width={this.props.containerWidth}
                viewMode={this.props.viewMode}
                onWidthChanged={this.props.onWidthChanged}
            />
        );
    }

}

const options = { debounce: 0 };

export default Dimensions(options)(ResponsiveCalendar);
